const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const filter = require('mn-utils/filter');
const find = require('mn-utils/find');
const toLower = require('mn-utils/toLower');
const reduce = require('mn-utils/reduce');
const isArray = require('mn-utils/isArray');
const FileDrop = require('react-file-drop').FileDrop;
const withState = require('../../../../utils/withState');
const Multiple = require('./Multiple');
const One = require('./One');
const Wrapper = require('./Wrapper');
const Empty = require('./Empty');

const ACCEPT = '.jpg, .jpeg, .png, .bmp, .gif, .pdf, .doc, .docx, .tif, .tiff';
const FILE_TYPES = ACCEPT.split(/\s*,\s*/);

function isValid(item) {
  const name = toLower(item.name);
  const l = FILE_TYPES.length;
  let i = 0;
  for (;i < l; i++) {
    if (name.endsWith(FILE_TYPES[i])) return true;
  }
  return false;
}

/*
<UploadA
  multiple
  limit={20} // files limit for multiple
  maxFileSize={1024*1024*25}
  buttonAtTheStart={false} // for multiple
  componentWrapper={null}
  componentAdd={null}
  componentEmpty={null}
  componentLoadingItem={null}
  componentReuploadItem={null}
  uploadUrl="/v1/doc/upload"
  apiUpload={apiDocUpload}
  apiRemove={apiDocRemove}
  value={docProofOfAddress}
  type="proof_of_address"
  onChange={handleDocProofOfAddress}
  onLoading={handleLoadingDocProofOfAddress}
  error={invalidDocProofOfAddress}
  openConfirm={handleOpenConfirm}
  openConfirmRemove={handleOpenConfirmRemove}
  {...custom}
/>
*/

module.exports = withState((setState) => {
  let clickedFileId = false;
  let clickedId = false;

  function handleClick({fileId, id}) {
    if (fileId && id) {
      clickedFileId = fileId;
      clickedId = id;
    }
    _fileInput && _fileInput.click();
  }
  function onRef(ref) {
    ref && (_fileInput = ref);
  }
  function handleOnDrag() {
    setState({drag: 1});
  }
  function handleOnLeave() {
    setState({drag: 0});
  }
  function getNextId() {
    return ++_lastId;
  }

  let _loading = false;

  let _fileInput;
  let _lastId = 0;
  return (state, props) => {
    const {
      disabled,
      value,
    } = props;
    const onChange = props.onChange || noop;
    const multiple = props.multiple || false;
    const onLoading = props.onLoading || noop;

    const ComponentWrapper = props.componentWrapper || Wrapper;
    const ComponentEmpty = props.componentEmpty || Empty;

    let files = value
      ? (isArray(value) ? value : [value])
      : [];
    const filesL = files.length;

    const Component = multiple
      ? Multiple
      : One;
    const hasValue = !!(multiple ? filesL : value);

    const loading = reduce(files, (a, v) => a || !(v && v.fileId), false);
    _loading === loading || delay(onLoading, 0, [_loading = loading]);

    const {
      drag,
    } = state;

    const limit = props.limit || 0;
    const maxFileSize = props.maxFileSize || 0;

    if (find(files, (v) => !v.id)) {
      files = map(files, (v) => {
        return v.id ? v : {
          ...v,
          id: getNextId(),
        };
      });
      delay(onChange, 0, [multiple ? files : files[0]]);
    }


    function __handleChangeFiles(nativeFiles) {
      setState({
        drag: 0,
      });

      if (clickedFileId) {
        props.apiRemove({
          id: clickedFileId,
        });

        clickedFileId = false;
      }

      if (!multiple || clickedId) {
        nativeFiles.length && (nativeFiles = [nativeFiles[0]])
      }

      const addition = map(filter(nativeFiles, isValid, []), (file) => {
        return {
          id: getNextId(),
          file,
          name: file.name,
        };
      }, []);

      nativeFiles.length !== addition.length
        && alert('This file format is not supported');

      let nextFiles = [];

      if (clickedId) {
        nextFiles = [...files];
        nextFiles[clickedId] = addition[0];
        clickedId = false;
      } else {
        nextFiles = [
          ...files,
          ...addition
        ]
      }

      const _files = limit
        ? nextFiles.slice(0, limit)
        : nextFiles;

      if (_files.length) {
        delay(onLoading, 0, [true]);
        delay(onChange, 0, [multiple ? _files : _files[0]]);
      }
    }


    const inner = (
      <ComponentWrapper
        className={props.className}
        disabled={disabled}
        drag={drag}
      >
        <input
          key={_lastId}
          className="dN"
          ref={onRef}
          type="file"
          accept={ACCEPT}
          multiple={multiple}
          onChange={(e) => {
            __handleChangeFiles(e.target.files);
          }}
        />
        {
          hasValue ? (
            <Component
              {...props}
              onClick={handleClick}
              limit={limit}
              files={files}
              onChange={onChange}
              onLoading={multiple ? noop : onLoading}
              setState={setState}
              maxFileSize={maxFileSize}
              value={multiple ? files : value}
              getNextId={getNextId}
            />
          ) : (
            <ComponentEmpty
              {...props}
              onClick={handleClick}
            />
          )
        }
      </ComponentWrapper>
    );

    return disabled ? inner : (
      <FileDrop
        onDragOver={handleOnDrag}
        onDragLeave={handleOnLeave}
        onDrop={__handleChangeFiles}
      >{inner}</FileDrop>
    );
  };
}, {});
